export default {
  translation: {
    'form.validation.required': '{{field_name}} is required',
    'form.validation.format':
      'Invalid {{field_name}}: The input contains unsupported symbols.',
    'form.validation.maxlength': '{{field_name}} is too long',
    'form.validation.minlength': '{{field_name}} is too short',
    'form.validation.invalid': '{{field_name}} is invalid',
    'form.validation.unique': '{{field_name}} is taken. Please choose again.',
    'membership.profile.optional_field': '(Optional)',
    'dropdown.hint': 'Please select',

    'member_points.title': 'Member Points',
    'member_points.unit': 'Point',
    'member_points.point_balance': 'Point Balance',
    'member_points.point_history': 'Point History',
    'member_points.fields.date': 'Date',
    'member_points.rule': 'Points Rules',
    'member_points.display.expire_point': 'points will expire on',
    'member_points.display.successive_expire_point':
      'points will expire in succession after',
    'member_points.fields.expire': '',
    'member_points.fields.expired': 'Point Expired',
    'member_points.fields.successive_expire': '',
    'member_points.fields.remarks': 'Point Change Reason',
    'member_points.fields.value': 'Point Movement',
    'member_points.fields.expiry_date': 'Expiry Date',
    'member_points.fields.member_point_expired': 'Point Expired',
    'member_points.fields.auto_reward': 'Points rewarded from order',
    'member_points.fields.auto_reward_seconds': '',
    'member_points.no_data': 'No point records',
    'member_points.equal_cash': 'Equal to {{money}}',
    'member_points.redeem_cash_description':
      'Every {{costPoint}} Points Discount {{discountMoney}}.',
    'member_points.fields.revert_member_point':
      'Points reverted from cancelled order',
    'member_points.fields.revert_member_point.return':
      'Points reverted from returned order',
    'member_points.fields.revert_member_point.order_split':
      'Points reverted from split order',
    'member_points.fields.revert_member_point.order_edit':
      'Points reverted from edited order',
    'member_points.fields.revert_member_point.return_order_revert':
      'Reverted points; from return',
    'member_points.fields.revert_member_point.order':
      'Reverted points; from order',
    'member_points.fields.product_review_reward':
      'Completed review for order <a></a>',
    'member_points.fields.member_info_reward':
      'Member Profile Completion Reward Member Points',
    'store_credits.fields.display.never_expired': 'Never Expired',
    'member_points.fields.order_redeemed': 'Points redeem to gift in order',
    'member_points.fields.redeemed_to_cash': 'Points redeem to cash in order',
    'member.center.load.more': 'More',
    'store_credits.fields.never_expires_point': 'Points Never Expired',
    'member_points.display.redeem_btn': 'Redeem Gifts',
    'promotions.page.term.confirm': 'Confirm',

    'store_credits.title': 'Store Credits',
    'store_credits.credit_balance': 'Credit Balance',
    'store_credits.credit_history': 'Credit History',
    'store_credits.fields.date': 'Date',
    'store_credits.fields.remarks': 'Credit Change Reason',
    'store_credits.fields.value': 'Credit Movement',
    'store_credits.fields.expiry_date': 'Expiry Date',
    'store_credits.fields.balance': 'Credit Balance',
    'store_credits.fields.order_prefix': 'Use of credits in order',
    'store_credits.fields.welcome_credit': 'Welcome Credit',
    'store_credits.fields.member_referral_credit':
      'Refer new member to sign up',
    'store_credits.fields.member_info_quick_completion_credit':
      'Member Profile Completion Reward Credits',
    'store_credits.fields.welcome_member_referral_credit':
      'Sign up with referral link',
    'store_credits.fields.birthday_credit': 'Birthday Credit',
    'store_credits.fields.user_credit_expired': 'Credit Expired',
    'store_credits.fields.never_expires': 'Never Expires',
    'store_credits.fields.auto_reward_prefix': 'Order ',
    'store_credits.fields.auto_reward': ' gets reward credits',
    'store_credits.fields.revert_credit':
      'Credits reverted from cancelled order',
    'store_credits.fields.revert_credit.return':
      'Credit Reverted from Returned order',
    'store_credits.fields.revert_credit.order_split':
      'Credits reverted from split order',
    'store_credits.fields.revert_credit.order_edit':
      'Credits reverted from edited order',
    'store_credits.fields.revert_credit.order': 'Reverted credits; from order',
    'store_credits.fields.revert_credit.return_order_revert':
      'Reverted credits; from return',
    'store_credits.fields.product_review_reward':
      'Completed review for order <a></a>',
    'store_credits.no_data': 'No credit records',
    'store_credits.bulk_imported': 'Manually added',

    'member_point.list.empty.description': 'Check out to earn more points!',
    'store_credits.list.empty.description': 'Check out to earn more credits!',
    'member_center.list.empty.buttonText': 'Go shopping!',
    // Member Profile
    'member_profile.member_info.title': 'Member Profile Completion Reward',
    'member_profile.member_info.name': 'Name',
    'member_profile.member_info.email': 'Email',
    'member_profile.member_info.mobile': 'Mobile number',
    'member_profile.member_info.gender': 'Gender',
    'member_profile.member_info.birthday': 'Birthday',
    'member_profile.member_info.symbol': ', ',
    'member_profile.member_info.hint.both':
      'Fill in the member information "{{fields}}", and subscribe to "{{subscriptions}}" to receive {{rewards}} upon completion.',
    'member_profile.member_info.hint.fields_only':
      'Fill in the member information "{{fields}}" to receive {{rewards}} upon completion.',
    'member_profile.member_info.hint.subscriptions_only':
      'Subscribe to "{{subscriptions}}" to receive {{rewards}} upon completion.',
    'member_profile.member_info.sent':
      'After the information check is completed, Member Profile Completion Reward will be issued!',
    'member_profile.member_info.user_credits': '${{count}} store credits',
    'member_profile.member_info.member_points': '{{count}} member points',
    'member_profile.member_info.coupons': '{{count}} coupons',
    'member_profile.member_info.subscription.email': 'Email',
    'member_profile.member_info.subscription.sms': 'SMS',
    'member_profile.member_info.subscription.line': 'LINE',
    'member_profile.member_info.subscription.facebook': 'Facebook Messenger',
    'member_profile.member_info.subscription.whatsapp': 'WhatsApp',
    'member_profile.member_referral.discount': 'Member Referral Campaign',
    'member_profile.member_referral.rules': 'Campaign Rules',
    'member_profile.member_referral.code.copy_and_share':
      'Share the link with your friend, you both get store credits.',
    'member_profile.member_referral.code.remarks': 'Campaign Rules',
    'member_profile.member_referral.generate': 'Referral link',
    'member_profile.member_referral.generate.success':
      'Referral link generated',
    'member_profile.member_referral.copy': 'Copy Link',
    'member_profile.member_referral.copy.success': 'Link Copied',
    'membership.profile.email': 'Email Address',
    'membership.profile.verification_hint':
      'If you change email address, verification is required after save. Email will be updated to {{unconfirmedEmail}} after verification is completed.',
    'membership.profile.verified_success': 'Verified',
    'membership.profile.not_verified_yet': 'Not verified yet',
    'membership.profile.send_verification_email': 'Send Verification email',
    'users.save.email_verification.success':
      'Your changes have been saved. Email address will be updated after verification is completed.',
    'users.save.email_verification.send': 'Verification Email Sent',
    'user.sign_up.email_verification.dialog.title':
      'Verification Email is sent to {{email}}',
    'user.sign_up.email_verification.dialog.description':
      'Please verify the email now and new email address will be updated. If you did not receive it, please input your email again and save.',
    'user.sign_up.email_verification.dialog.confirm': 'Confirm',

    'users.membership.member_info.title': 'Member Profile Completion Reward',
    'users.membership.member_info.hint':
      'Fill in the following member information: {{fields}}, you can get {{rewards}} after filling the profile information',
    'users.membership.member_info.sent':
      'After the information check is completed, Member Profile Completion Reward will be issued!',
    'users.membership.member_info.symbol': ', ',
    'users.membership.member_info.name': 'Name',
    'users.membership.member_info.email': 'Email',
    'users.membership.member_info.mobile': 'Mobile number',
    'users.membership.member_info.gender': 'Gender',
    'users.membership.member_info.gender.male': 'Male',
    'users.membership.member_info.gender.female': 'Female',
    'users.membership.member_info.gender.other': 'Undisclosed',
    'users.membership.member_info.birthday': 'Birthday',
    'users.membership.member_info.password': 'Password',
    'users.membership.member_info.password.change': 'Set new password',
    'users.membership.member_info.account_binding': 'Third-Party Account',
    'users.membership.member_info.user_credits': '${{count}} store credits',
    'users.membership.member_info.member_points': '{{count}} member points',
    'users.membership.member_info.coupons': '{{count}} coupons',
    'users.membership.forget_password.email_sent':
      'We have sent an email to {{email}}. Open the email and reset your password.',
    'users.member.normal-level': 'Basic',
    'users.membership.expiry_date': 'Membership Expiry Date',
    'users.membership.expire.unlimited': 'Never Expire',
    'users.membership.expire.month_valid':
      '（Valid Period {{months}} Month(s))',
    'users.membership.tier.expire.date.description':
      'Upgrade condition will be checked during midnight. Membership upgrade will not be effective if order has been cancelled/refunded.',
    'users.membership.tier.expire.date.auto_downgrade.description':
      'Upgrade condition will be checked during midnight. Membership upgrade will not be effective if order has been cancelled/refunded.',
    'users.membership.tier.extension.date.description':
      'Membership extension will not be effective if order has been cancelled/refunded.',
    'users.membership.offer.discount': 'Membership Offer',
    'users.membership.upgrade.next_tier': 'Upgrade to {{tier_name}}',
    'users.membership.upgrade.next_tier.discount': ', get {{discount}}% off',
    'users.membership.extension.condition': 'Extension Condition',
    'users.membership.extension.status': 'Membership Extend Status',
    'users.membership.max_level_tier':
      'Congrats! You are in TOP membership level.',
    'users.membership.spending_within_months':
      'Upgrade with total purchase over {{spending}} within {{months}} month(s).',
    'users.membership.spending_single_purchase':
      'Upgrade with single purchase over {{spending}}.',
    'users.membership.all.spending_within_months':
      'Total purchase over {{spending}} within {{months}} month(s).',
    'users.membership.all.spending_single_purchase':
      'Single purchase over {{spending}}.',
    'users.membership.extend_valid_period':
      '{{type}} purchase over {{spending}} within membership valid period {{months}} months.',
    'users.membership.within_interval': 'Total',
    'users.membership.single_purchase': 'Single',
    'users.membership.all_tiers': 'View All Membership',
    'users.membership.all_tiers.condition': 'Membership',
    'users.membership.all_tiers.description':
      'Membership will downgrade on expiry date if extension condition is not meet.',
    'users.membership.tier.shopping_discount': 'Member offer {{discount}}% off',
    'users.membership.tier.upgrade.condition':
      'Upgrade Condition of this level :',
    'users.membership.tier.upgrade.condition.dollar':
      'No single purchase over {{dollar}} currently.',
    'users.membership.tier.upgrade.condition.continue': 'Continue Shopping!',
    'users.membership.tier.extend': 'Eligible to extend {{tier}}?',
    'users.membership.tier.upgrade.to_next_level.single':
      'Upgrade to next level ?',
    'users.membership.tier.upgrade.to_next_level.within':
      'Total purchase within {{month}} month(s) ',
    'users.membership.tier.upgrade.completed': 'Eligible to upgrade.',
    'users.membership.tier.upgrade.gap_dollar': '{{dollar}} more to upgrade',
    'users.membership.tier.expire.date': 'Valid Period :',
    'users.membership.tier.extend.condition': ' Extension Condition :',
    'users.membership.tier.extend.single_purchase':
      'No single purchase over {{dollar}} within {{month}}-month membership valid period.',
    'users.membership.tier.extend.single_purchase.can_extend':
      'You have a single purchase over {{dollar}} within {{month}}-month membership valid period. Membership extension will be effective on expiry date.',
    'users.membership.tier.extend.top_level.single_purchase':
      'No single purchase over {{dollar}} within {{month}}-month membership valid period.',
    'users.membership.tier.extend.top_level.single_purchase.can_extend':
      'You have a single purchase over {{dollar}} within membership valid period. Congrats! Membership extension will be effective on expiry date.',
    'users.membership.tier.extend.within_interval':
      'Your total purchase within {{month}}-month membership valid period is {{spending}}. {{dollar}} more to extend.',
    'users.membership.tier.extend.within_interval.can_extend':
      'Your total purchase within {{month}}-month membership valid period is over {{dollar}}. Extension will be effective on expiry date.',
    'users.membership.tier.extend.top_level.within_interval':
      '{{dollar}} more to extend',
    'users.membership.tier.extend.top_level.within_interval.can_extend':
      'Congrats! Extension will be effective on expiry date.',
    'users.membership.tier.expire.month': '{{month}} Month(s)',
    'users.membership.tier.discount_percentage.caption': '{{ value }}% off',

    'membership.profile.birthday': 'Birthday',
    'birthday_picker.year.placeholder': 'Year',
    'birthday_picker.month.placeholder': 'Month',
    'birthday_picker.date.placeholder': 'Date',
    'form.validation.birthday.required': 'Birthday is required',
    'form.validation.birthday.invalid': 'Birthday is invalid',
    'form.validation.birthday.invalid.minimum_age_limit':
      'Birthday is invalid, should over {{minimumAgeLimit}} years old.',
    'users.birthday.faq':
      'You should over certain age to register and shop at the online store.',
    'membership.edit.send_me_check_mode': 'Send me check code',
    'membership.edit.select_saved_mobile_number':
      'Select a saved contact number',
    'session.mobile_signup.check_mobile.title':
      'Please check your mobile number is correct as following, sms is sending to this mobile number',
    'session.mobile_signup.check_mobile.your_number': 'Your mobile number',
    'session.mobile_signup.check_mobile.send_code': 'Send me check code',
    'session.mobile_signup.check_mobile.go_back.1': 'you can',
    'session.mobile_signup.check_mobile.go_back.2': 'go back',
    'session.mobile_signup.check_mobile.go_back.3':
      'to correct mobile number if it is wrong',
    'session.mobile_signup.check_mobile.go_back.3.simplified':
      'to correct mobile number',
    'session.mobile_signup.input_code.hint':
      'Please input check code you received',
    'session.mobile_signup.input_code.hint.simplified':
      'Please input check code you received',
    'session.mobile_signup.input_code.placeholder': 'Check code',
    'session.mobile_signup.input_code.submit': 'Go',
    'session.mobile_signup.input_code.resend.countdown':
      'Resend check code sms to my mobile ({{resendCountdown}} sec)',
    'session.mobile_signup.input_code.resend.countdown.simplified':
      'Resend check code ({{resendCountdown}} sec)',
    'session.mobile_signup.input_code.resend':
      'Resend check code sms to my mobile',
    'session.mobile_signup.input_code.resend.simplified': 'Resend check code',
    'session.forget_passowrd.check_phone.error':
      'Mobile number incorrect, please check again',
    'session.mobile_center.check_phone.error': 'Mobile number is already taken',
    'user.sign_up.check_phone.error':
      'This is same as current mobile phone.<br>Please change another phone if you want to update it.',
    'membership.profile.mobile.number.verified':
      'Mobile number verified and it will replace phone numbers you saved before.',
    'membership.profile.delivery_addresses': 'Saved Delivery Addresses',
    'users.add.delivery_address.maximum': 'You may only add up to 5 addresses.',
    'users.add.delivery_address': 'Add new address',
    'checkout.address.recipient': 'Recipient Name',
    'checkout.address.recipient_phone': 'Recipient Phone Number',
    'member_profile.line.subscribe.error.already_in_used':
      'This LINE account is already in use by another member. Please contact the store for assistance.',
    'member_profile.subscribe': 'Subscribe',
    'member_profile.subscribed': 'Subscribed',
    'member_profile.notification.promotion': 'Promotion Notification',
    'member_profile.notification.order': 'Order Notification',
    'member_profile.subscribe.successfully': 'Subscribed successfully.',
    'member_profile.subscribe.error':
      'Failed to subscribe. Please contact the store.',
    'member_profile.line.subscribe.error.already_for_registration':
      'Failed to subscribe. This LINE account is already used for registration by another member. Please log in with the LINE account and try again.',
    'member_profile.line.subscribe.error.different_id':
      'Failed to subscribe. Please log in with the LINE account of the member account.',
    'member_profile.line.subscribe.error':
      'Failed to subscribe. Please log in to LINE again.',
    'member_profile.facebook.subscribe.error':
      'Failed to subscribe. Please log in to Facebook again.',
    'member_profile.social.subscribe.error.already_bound_to':
      'Failed to subscribe. This social account is already bound to another member. Please contact the store to unbind.',
    'member_profile.email.subscribe.error':
      'Failed to subscribe. Please enter an email address and try again.',
    'member_profile.sms.subscribe.error':
      'Failed to subscribe. Please enter a mobile number and try again.',
    'member_profile.unsubscribe.successfully': 'Unsubscribed successfully.',
    'member_profile.unsubscribe.error':
      'Failed to unsubscribed, please try again later.',
    'member_profile.error.unknown': 'Oops! An unexpected error has occurred.',
    'member_profile.error.refresh':
      'Please refresh the page or try again later.',
    'member_profile.retry': 'Try again',
    'member_profile.profile': 'Member profile',
    'member_profile.subscription': 'Subscription',
    'member_profile.delivery_payment': 'Delivery and payment info',
    'member_profile.phone': 'Contact Phone',

    'user.credit_card.title': 'Credit Card',
    'user.credit_card.information':
      'Credit Card Information (Can save {{ max }} credit cards)',
    'user.add_credit_card': 'Add a credit card',
    'user.add_credit_card.credit_card_limit':
      'You may only add up to {{ max }} credit cards.',
    'user.add_credit_card.success': 'The card has been added successfully.',
    'user.add_credit_card.fail':
      'Failed to add the credit card, please try again later',
    'user.add_credit_card.cancel': 'Cancel',
    'user.add_credit_card.remind':
      'Note: {{ label }} will be deducted as verification fee. It will be refunded to your card afterwards.',
    'user.add_credit_card.submit': 'Submit',
    'user.delete_credit_card':
      'Are you sure you want to delete the credit card from your account?',
    'user.delete_credit_card.description':
      'Once the credit card has been deleted, you need to re-enter card number for checkout next time.',
    'user.delete_credit_card.description.with_subscription_product':
      'Once the credit card has been deleted, you need to re-enter card number for checkout next time. If you had paid by this credit card for subscription orders, it will failed to complete the payment for the next order. You may go to Member > Orders to repay.',
    'user.delete_credit_card.success':
      'The card has been deleted successfully.',
    'user.delete_credit_card.fail':
      'Failed to delete the credit card, please try again later',
    'user.delete_credit_card.cancel': 'Cancel',
    'user.delete_credit_card.delete': 'Delete',
    'user.credit_card.expired': 'Expired',
    'user.credit_card_list.delete': 'Delete',
    'user.credit_card_list.processing': 'Processing',
    'users.invoice_carrier': '發票載具',
    'users.electronic_invoice_carrier': 'Sum up E-invoice into your account',
    'member_profile.confirm': 'Save Changes',
    'member_profile.cancel': 'Cancel',
    'users.save.success': 'Your changes have been saved.',
    'users.error.not_save_mobile_phone':
      'Please verify this phone number before saving change.',
    'verification.email.trial_merchant.reach_limit.failure':
      'The verification email is not available during the trial operation of the store. If needed, please contact the store for assistance.',
    'Subscription - Facebook - Dialog - title': 'Subscribe to Facebook',
    'Subscription - Facebook - Dialog - info': `Due to updates in Facebook’s messaging guidelines, please complete the subscription process on Messenger. Click "Subscribe now" and you will be directed to Messenger.<1 />Log in to Messenger and <2>click the "Get Started" button</2> in the chat. You will be redirected to Messenger to complete the subscription. (If you've previously messaged the store's Facebook Page, opening the conversation on Messenger will be considered a successful subscription.)`,
    'Subscription - Facebook - Dialog - cancel': 'Cancel',
    'Subscription - Facebook - Dialog - subscribe': 'Subscribe now',
  },
};
